"use client"

import { createPortal } from "react-dom"
import { NpButton } from "src/components/np-design/components/button/NpButton"
import { useIsClient } from "src/hooks/useIsClient"
import { setGlobalErrorMessage, useGlobalErrorMessage } from "./state"

const closeGlobalErrorMessage = () => setGlobalErrorMessage(null)

export const GlobalErrorFeedback = () => {
  const isClient = useIsClient() // required because portals only work on the client
  const errorMessage = useGlobalErrorMessage()

  if (!isClient || !errorMessage) {
    return null
  }

  const portalContainer = document.querySelector("main")!
  const portalChildren = (
    <div className="z-global-error bg-np-red fixed top-0 right-0 left-0 m-4 flex items-center gap-2 rounded-3xl border border-white p-2 pl-6 text-white shadow-xl transition-opacity duration-300 sm:left-auto sm:max-w-120">
      {errorMessage}

      <NpButton
        iconNameLeft="close"
        variant="ghost"
        color="gray10"
        size="md"
        onClick={closeGlobalErrorMessage}
        title="Schließen"
      />
    </div>
  )

  return <>{createPortal(portalChildren, portalContainer)}</>
}
